(() => {
  const handleVideos = (slideshowElement) => {
    const videos = slideshowElement.querySelectorAll('.slideshow__video video');

    if (slideshowElement.swiper && slideshowElement.swiper.initialized) {
      videos.forEach((video) => {
        if (video.closest('.swiper-slide-visible')) {
          video.play();
        } else {
          video.pause();
        }
      });
    } else if (slideshowElement.closest('[data-slide-count="1"]')) {
      videos.forEach((video) => video.play());
    }
  };

  const setupSlideshow = (sectionElement) => {
    if (!sectionElement?.classList.contains('section-slideshow')) return;

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const slideshow = sectionElement.querySelector('.slideshow');
        if (!slideshow) return;

        const prevBtn = slideshow.querySelector('.swiper-button-prev');
        const nextBtn = slideshow.querySelector('.swiper-button-next');

        const config = {
          speed: 800,
          autoHeight: false,
          allowTouchMove: true,
          mousewheel: { forceToAxis: true },
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
        };

        const updateColorScheme = (swiper) => {
          const viewportWidth = window.innerWidth;
          const activeIndex = swiper.activeIndex;
          const activeSlide = swiper.slides[activeIndex];
          let threshold = 0;

          const parent = swiper.el.parentNode;
          const targets = [swiper.navigation.nextEl, swiper.navigation.prevEl, swiper.pagination.el];

          if (parent.classList.contains('slideshow__swiper--simple')) {
            threshold = 990;
            targets.push(parent);
          }

          if (
            swiper.el.classList.contains('slideshow__swiper--overlay') ||
            swiper.el.classList.contains('slideshow__swiper--grid')
          ) {
            threshold = 0;
          }

          const scheme = activeSlide?.dataset?.colorScheme;

          targets.forEach((el) => {
            if (!el) return;
            const cleanClass = el.getAttribute('class')?.replace(/color-background-\d+/g, '') || '';
            el.setAttribute('class', cleanClass);
            if (viewportWidth >= threshold && scheme) {
              el.classList.add(scheme);
            }
          });
        };

        // Config options based on data-attributes
        if (slideshow.getAttribute('data-autoplay') === 'true') {
          config.autoplay = { disableOnInteraction: true };
        }
        if (slideshow.getAttribute('data-pagination') === 'true') {
          config.pagination = {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: false,
          };
        }
        if (slideshow.getAttribute('data-navigation') === 'true') {
          config.navigation = {
            nextEl: nextBtn,
            prevEl: prevBtn,
          };
        }
        if (slideshow.getAttribute('data-parallax') === 'true' && slideshow.getAttribute('data-layout') !== 'grid') {
          config.parallax = true;
        }
        if (slideshow.getAttribute('data-enable-loop') === 'true') {
          config.loop = true;
        }
        if (slideshow.getAttribute('data-layout') === 'grid') {
          config.breakpoints = {
            750: {
              slidesPerView: 'auto',
            },
          };
        }

        const slideCount = Number(slideshow.getAttribute('data-slide-count') || 0);

        if (slideCount <= 1) return;

        const layout = slideshow.getAttribute('data-layout');

        if (layout === 'simple') {
          const textSwiperEl = slideshow.querySelector('.slideshow__swiper--text');
          const mediaSwiperEl = slideshow.querySelector('.slideshow__swiper--media');

          if (textSwiperEl && mediaSwiperEl) {
            const textSwiper = new Swiper(textSwiperEl, config);
            const mediaSwiper = new Swiper(mediaSwiperEl, {
              ...config,
              autoplay: false,
              pagination: false,
              navigation: false,
              parallax: false,
            });

            textSwiper.controller.control = mediaSwiper;
            mediaSwiper.controller.control = textSwiper;

            updateColorScheme(textSwiper);

            textSwiper.on('beforeTransitionStart', function () {
              updateColorScheme(this);
            });

            mediaSwiper.on('beforeTransitionStart', function () {
              updateColorScheme(textSwiper);
            });

            mediaSwiper.on('slideChange', function () {
              handleVideos(mediaSwiperEl);
            });
          }
        } else if (layout === 'overlay') {
          const overlaySwiperEl = slideshow.querySelector('.slideshow__swiper--overlay');
          if (overlaySwiperEl) {
            const overlaySwiper = new Swiper(overlaySwiperEl, {
              ...config,
              effect: 'creative',
              creativeEffect: {
                prev: { translate: [0, 0, -400] },
                next: { translate: ['100%', 0, 0] },
              },
            });

            updateColorScheme(overlaySwiper);

            overlaySwiper.on('beforeTransitionStart', function () {
              updateColorScheme(this);
            });

            overlaySwiper.on('slideChange', function () {
              handleVideos(overlaySwiperEl);
            });
          }
        } else if (layout === 'grid') {
          const gridSwiperEl = slideshow.querySelector('.slideshow__swiper--grid');
          if (gridSwiperEl) {
            const gridSwiper = new Swiper(gridSwiperEl, config);

            updateColorScheme(gridSwiper);

            gridSwiper.on('beforeTransitionStart', function () {
              updateColorScheme(this);
            });

            gridSwiper.on('slideChange', function () {
              handleVideos(gridSwiperEl);
            });
          }
        }
      });
    }).observe(sectionElement);
  };

  const observeVideoPlayPause = (sectionElement) => {
    if (!sectionElement?.classList.contains('section-slideshow')) return;

    const slideshow = sectionElement.querySelector('.slideshow');
    if (!slideshow) return;

    let swiperElement;

    const layout = slideshow.getAttribute('data-layout');
    if (layout === 'simple') {
      swiperElement = sectionElement.querySelector('.slideshow__swiper--media');
    } else if (layout === 'overlay') {
      swiperElement = sectionElement.querySelector('.slideshow__swiper--overlay');
    } else if (layout === 'grid') {
      swiperElement = sectionElement.querySelector('.slideshow__swiper--grid');
    }

    if (!swiperElement) return;

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isIntersecting = entry.isIntersecting;

        if (isIntersecting) {
          handleVideos(swiperElement);
          if (swiperElement.swiper && slideshow.getAttribute('data-autoplay') === 'true') {
            swiperElement.swiper.autoplay.resume();
          }
        } else {
          const videos = swiperElement.querySelectorAll('.slideshow__video video');

          if (swiperElement.swiper?.initialized) {
            videos.forEach((v) => v.pause());
          } else if (swiperElement.closest('[data-slide-count="1"]')) {
            videos.forEach((v) => v.play());
          }

          if (swiperElement.swiper && slideshow.getAttribute('data-autoplay') === 'true') {
            swiperElement.swiper.autoplay.pause();
          }
        }
      });
    }).observe(sectionElement);
  };

  const initOnLoad = (section) => {
    setupSlideshow(section);
    observeVideoPlayPause(section);
  };

  // Run on current section
  initOnLoad(document.currentScript.parentElement);

  // Run on dynamically loaded sections
  document.addEventListener('shopify:section:load', (e) => {
    initOnLoad(e.target);
  });
})();
